import styled from "styled-components";

export const sizeMap = {
  sm: "20px",
  md: "30px",
  lg: "50px",
};

export const LoaderContainer = styled.div`
    display:flex;
    align-items:center;
    padding:5px;
`;

export const LoaderText = styled.div`
    margin-left:10px;
`;
